export const linkToAccountSettings = () => {
  return "/account";
};

export const linkToSubscription = () => {
  return "/subscription";
};

export const linkToTeam = () => {
  return "/team";
};

export const linkToSettings = (wokrspaceId) => {
  return `/w/${wokrspaceId}/settings`;
};

export const linkToCampaigns = (wokrspaceId) => {
  return `/w/${wokrspaceId}/campaigns`;
};

export const linkToCampaign = (wokrspaceId, campaignId) => {
  return `/w/${wokrspaceId}/campaigns/${campaignId}`;
};
export const linkToChats = (wokrspaceId) => {
  return `/w/${wokrspaceId}/chats`;
};
export const linkToChat = (wokrspaceId, id) => {
  return `/w/${wokrspaceId}/chats/${id}/edit`;
};
export const linkToChatFolder = (wokrspaceId, id) => {
  return `/w/${wokrspaceId}/chats/${id}`;
};
export const linkToApiKeys = (wokrspaceId) => {
  return `/w/${wokrspaceId}/keys`;
};

export const linkToPrompts = (wokrspaceId) => {
  return `/w/${wokrspaceId}/prompts`;
};

export const linkToPrompt = (wokrspaceId, promptId) => {
  return `/w/${wokrspaceId}/prompts/${promptId}`;
};

export const linkToPromptVersion = (wokrspaceId, promptId, versionId) => {
  return `/w/${wokrspaceId}/prompts/${promptId}/${versionId}`;
};

export const linkToForms = (wokrspaceId) => {
  return `/w/${wokrspaceId}/forms`;
};

export const linkToForm = (wokrspaceId, id) => {
  return `/w/${wokrspaceId}/forms/${id}`;
};

export const linkToEndpoints = (wokrspaceId) => {
  return `/w/${wokrspaceId}/endpoints`;
};

export const linkToEndpoint = (wokrspaceId, id) => {
  return `/w/${wokrspaceId}/endpoints/${id}`;
};

export const linkToFlows = (wokrspaceId) => {
  return `/w/${wokrspaceId}/flows`;
};

export const linkToFlow = (wokrspaceId, id) => {
  return `/w/${wokrspaceId}/flows/${id}`;
};

export const linkToSubmission = (wokrspaceId, campaignId, uid) => {
  return `/w/${wokrspaceId}/campaigns/${campaignId}/submissions/${uid}`;
};

export const linkToUserSubmission = (campaignId, submissionId) => {
  return `/interview/${campaignId}/${submissionId}`;
};

export const linkToHubStart = () => {
  return "/hub/start";
};
export const linkToHubModels = () => {
  return "/hub/models";
};
export const linkToHubModel = (handle) => {
  return "/hub/models/" + handle;
};

export const linkToHubModelDetails = (handle) => {
  return "/hub/models/" + handle;
};

export const linkToHubJobDetails = (handle, jobId) => {
  return "/hub/models/" + handle + "/jobs/" + jobId;
};

export const linkToOther = () => {
  return "/other";
};

export const linkToChatbotList = () => {
  //return "/ai/chatbots";
  return "/";
};

export const linkToChatbot = (id, tabId) => {
  return "/ai/chatbots/" + id + "/" + tabId;
};

export const linkToMcpServers = () => {
  return "/mcp-servers";
};

export const linkToMcpServer = (id) => {
  return "/mcp-servers/" + id;
};

/** New Workspace */
export const linkToNewChats = (workspaceId) => {
  return `/workspaces/${workspaceId}/chats`;
};
export const linkToNewChatFolder = (workspaceId, id) => {
  return `/workspaces/${workspaceId}/chats/${id}`;
};
export const linkToNewChat = (wokrspaceId, id) => {
  return `/workspaces/${wokrspaceId}/chats/${id}/edit`;
};
export const linkToVendorKeys = (workspaceId) => {
  return `/workspaces/${workspaceId}/vendor-keys`;
};

export const linkToIntegrations = (workspaceId) => {
  return `/workspaces/${workspaceId}/integrations`;
};

export const linkToWorkspaceSettings = (wokrspaceId) => {
  return `/workspaces/${wokrspaceId}/settings`;
};
export const linkToNewPrompts = (workspaceId) => {
  return `/workspaces/${workspaceId}/prompts`;
};
export const linkToNewPrompt = (workspaceId, promptId) => {
  return `/workspaces/${workspaceId}/prompts/${promptId}`;
};
export const linkToNewPromptVersion = (workspaceId, promptId, versionId) => {
  return `/workspaces/${workspaceId}/prompts/${promptId}/${versionId}`;
};
export const linkToNewFlows = (workspaceId) => {
  return `/workspaces/${workspaceId}/flows`;
};
export const linkToNewFlow = (workspaceId, id) => {
  return `/workspaces/${workspaceId}/flows/${id}`;
};
export const linkToToolPlugins = (workspaceId) => {
  return `/workspaces/${workspaceId}/tool-plugins`;
};
export const linkToToolPlugin = (workspaceId, id) => {
  return `/workspaces/${workspaceId}/tool-plugins/${id}`;
};
export const linkToKnowledgeBases = (workspaceId) => {
  return `/workspaces/${workspaceId}/knowledge`;
};
export const linkToKnowledgeBase = (workspaceId, id, tabId) => {
  if (tabId) {
    return `/workspaces/${workspaceId}/knowledge/${id}/${tabId}`;
  }
  return `/workspaces/${workspaceId}/knowledge/${id}/files`;
};
export const linkToAssistants = (workspaceId) => {
  return `/workspaces/${workspaceId}/assistants`;
};
export const linkToAssistant = (workspaceId, id) => {
  return `/workspaces/${workspaceId}/assistants/${id}`;
};
export const linkToGateways = (workspaceId) => {
  return `/workspaces/${workspaceId}/gateways`;
};
export const linkToGateway = (workspaceId, id) => {
  return `/workspaces/${workspaceId}/gateways/${id}`;
};

export const linkToBuilder = (workspaceId) => {
  return `/workspaces/${workspaceId}/builder`;
};
export const linkToBuilderNewProject = (workspaceId) => {
  return `/workspaces/${workspaceId}/builder/new`;
};
export const linkToBuilderProject = (workspaceId, chatUid) => {
  return `/workspaces/${workspaceId}/builder/${chatUid}`;
};
export const linkToTemplates = (workspaceId) => {
  return `/workspaces/${workspaceId}/builder/templates`;
};
export const linkToTemplateDetail = (workspaceId, templateUid) => {
  return `/workspaces/${workspaceId}/builder/templates/${templateUid}`;
};
